// extracted by mini-css-extract-plugin
module.exports = {"button":"AssessmentButton_button__zl-0f","return":"AssessmentButton_return__3_Qo5","save":"AssessmentButton_save__1XBCM"};